import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getOgForPath, SITE_ORIGIN } from "@/lib/seoConfig";

/**
 * Updates document title + OG tags when the route changes (in-browser).
 * WhatsApp / iMessage crawlers only read public/index.html — keep absolute og:image there too.
 */
export default function SeoMeta() {
    const { pathname } = useLocation();

    useEffect(() => {
        const og = getOgForPath(pathname);
        const pageUrl = `${SITE_ORIGIN}${pathname === "/" ? "" : pathname}`;

        document.title = og.title;

        const upsert = (selector, attrName, attrValue, content) => {
            let el = document.head.querySelector(selector);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attrName, attrValue);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };

        upsert('meta[name="description"]', "name", "description", og.description);
        upsert('meta[property="og:title"]', "property", "og:title", og.title);
        upsert(
            'meta[property="og:description"]',
            "property",
            "og:description",
            og.description,
        );
        upsert('meta[property="og:url"]', "property", "og:url", pageUrl);
        upsert('meta[property="og:image"]', "property", "og:image", og.image);
        upsert(
            'meta[property="og:image:secure_url"]',
            "property",
            "og:image:secure_url",
            og.image,
        );
        upsert(
            'meta[property="og:image:width"]',
            "property",
            "og:image:width",
            String(og.imageWidth),
        );
        upsert(
            'meta[property="og:image:height"]',
            "property",
            "og:image:height",
            String(og.imageHeight),
        );
        upsert(
            'meta[property="og:image:type"]',
            "property",
            "og:image:type",
            "image/jpeg",
        );
        upsert('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
        upsert('meta[name="twitter:title"]', "name", "twitter:title", og.title);
        upsert(
            'meta[name="twitter:description"]',
            "name",
            "twitter:description",
            og.description,
        );
        upsert('meta[name="twitter:image"]', "name", "twitter:image", og.image);

        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", pageUrl);
    }, [pathname]);

    return null;
}
